import React from 'react';

class RowItemXLDKhieuNaiToCao extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSoDonTiepNhanXLDTCD}</td>
        <td className='txt-center'>{data.tongSoDonCoNhieuNguoiDungTenTiepNhanDonTiepNhanDonTrongKy}</td>
        <td className='txt-center'>{data.tongSoDonCoMotNguoiDungTenTiepNhanDonTiepNhanDonTrongKy}</td>
        <td className='txt-center'>{data.tongSoDonCoNhieuNguoiDungTenTiepNhanDonDonKyTruocChuyenSang}</td>
        <td className='txt-center'>{data.tongSoDonCoMotNguoiDungTenTiepNhanDonDonKyTruocChuyenSang}</td>
        <td className='txt-center'>{data.tongSoDonDuDieuKienThuLy}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucHanhChinh}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucHanhChinhLienQuanDenDatDai}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucHanhChinhVeNhaVaTaiSan}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucHanhChinhVeChinhSachCheDoCCVC}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucHanhChinhLinhVucKTCTXHKhac}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucTuPhap}</td>
        <td className='txt-center'>{data.tongSoDonKhieuNaiLinhVucVeDang}</td>
        <td className='txt-center'>{data.tongSoDonLinhVucToCao}</td>
        <td className='txt-center'>{data.tongSoDonToCaoLinhVucHanhChinh}</td>
        <td className='txt-center'>{data.tongSoDonToCaoLinhVucTuPhap}</td>
        <td className='txt-center'>{data.tongSoDonToCaoLinhVucThamNhung}</td>
        <td className='txt-center'>{data.tongSoDonToCaoLinhVucVeDang}</td>
        <td className='txt-center'>{data.tongSoDonToCaoLinhVucKhac}</td>
        <td className='txt-center'>{data.tongSoDonTheoTQGQCuaCacCoQuanHanhChinhCacCap}</td>
        <td className='txt-center'>{data.tongSoDonTheoTQGQCuaCacCoQuanTuPhapCacCap}</td>
        <td className='txt-center'>{data.tongSoDonTheoTQGQCuaCoQuanDang}</td>
        <td className='txt-center'>{data.tongSoDonTheoTTGiaiQuyetChuaGiaiQuyet}</td>
        <td className='txt-center'>{data.tongSoDonTheoTTGiaiQuyetDaDuocGiaiQuyet}</td>
        <td className='txt-center'>{data.tongSoDonXLDDonKienNghiPhanAnh}</td>
        <td className='txt-center'>{data.tongSoDonXLDSoVanBanHuongDan}</td>
        <td className='txt-center'>{data.tongSoDonChuyenCQCoThamQuyen}</td>
        <td className='txt-center'>{data.tongSoDonCoSoCongVanDonDocViecGiaiQuyet}</td>
        <td className='txt-center'>{data.tongSoDonThuocThamQuyenKhieuNai}</td>
        <td className='txt-center'>{data.tongSoDonThuocThamQuyenToCao}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemXLDKhieuNaiToCao;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemXLDKhieuNaiToCao.jsx